
import axios from 'axios';
import { environment } from './Environments/environment';


export class AppService {

    public saveUser(email: string, isGuest: boolean = false) {
        var request = { user: { email, isGuest } };
        return axios.post(`${environment.dueDiligenceApiUrl}/User/Save`, request);
    }

    public userExists(email: string) {
        return axios.get(`${environment.dueDiligenceApiUrl}/User/get?email=${email}`);
    }

    public saveDueDiligence(email: string, values: any) {
        var request = { userEmail: email, dueDiligenceInput: values };
        return axios.post(`${environment.dueDiligenceApiUrl}/DueDiligence/Save`, request);
    }

    public getDueDiligence(email: string) {
        return axios.get(`${environment.dueDiligenceApiUrl}/DueDiligence/Get?userEmail=${email}`);
    }

    public saveFile(data: FormData) {
        return axios.post(`${environment.dueDiligenceApiUrl}/DueDiligence/FileUpload`, data);
    }
}